<template>
  <v-container fluid>
    <v-row class="px-0 py-0 my-0">
      <v-col cols="7" class="d-md-flex">
        <RangeFilter
            style="margin-top: 0!important;"
            :end="dateEnd"
            :start="dateStart"
            @getDates="getDates"
            :excludePeriod="excludePeriod"
            :defaultPeriod="defaultPeriod"
            :setDates="true"
            :disabled="loaded"
        />
        <v-switch
            v-model="isCompareFilter"
            hide-details
            color="orange darken-3"
            class="mx-5 mt-md-1 my-3 mb-md-0"
        >
          <template #label>
            <span class="ml-1">Compare</span>
          </template>
        </v-switch>
        <CompareFilter
            v-if="isCompareFilter"
            :end="dateCompareEnd"
            :start="dateCompareStart"
            :periodStart="dateStart"
            :periodEnd="dateEnd"
            @getDates="getCompareDates"
            :bgColor="compareFilterColor"
            :filterIcon="compareIcon"
            :diffDays="diffDays"
            :disabled="loaded"
        />

      </v-col>
      <v-spacer></v-spacer>
      <last-time-updated :selectedDate="'updateOrders'" class=" mt-0 mt-md-4"/>
    </v-row>
    <v-card class="elevation-2 py-1 px-6 mt-4 rounded-lg">
      <v-row>
        <v-col cols="12" sm="4" md="2">
          <v-select
              :items="chartsType"
              v-model="selectedChartType"
              label="Chart Type"
              outlined
              dense
              hide-details
          ></v-select>
        </v-col>
        <v-col cols="12" sm="4" md="2">
          <v-select
              :items="charts"
              v-model="selectedChart"
              label="Select Chart"
              outlined
              dense
              hide-details
          ></v-select>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <v-autocomplete
              dense
              v-model="filtered.products"
              :items="filters.productName"
              :menu-props="{ maxHeight: '200' }"
              label="Product Type"
              multiple
              outlined
              hide-details
          >
            <template v-slot:selection="{ item, index }">
              <v-chip v-if="index < 2" text-color="grey darken-4" class="grey lighten-3">
                <span class="">{{ item }}</span>
              </v-chip>
              <span
                  v-if="index === 2"
                  class="grey--text chip-counter"
              >
                (+{{ filtered.products.length - 2 }} {{ (filtered.products.length - 2) > 1 ? 'others' : 'another' }})
              </span>
            </template>
          </v-autocomplete>
        </v-col>
        <v-col cols="12" sm="4" md="2" v-show="false">
          <v-checkbox label="Show All Areas"
                      v-model="showAllAreas"
                      color="indigo"
                      class="mt-2 mr-2"
          ></v-checkbox>
        </v-col>

      </v-row>
    </v-card>
    <v-row>
      <v-col cols="12">
        <v-progress-linear
            indeterminate
            color="indigo"
            v-if="loaded"
        ></v-progress-linear>
        <highcharts ref="chart4" :constructor-type="'mapChart'" :options="chartOptions4" class="mx-10 mt-10"
                    v-show="selectedChart === 'Orders' && selectedChartType === 'World'"></highcharts>
        <highcharts ref="chart5" :constructor-type="'mapChart'" :options="chartOptions5" class="mx-10 mt-10"
                    v-show="selectedChart === 'Gallons' && selectedChartType === 'World'"></highcharts>
        <highcharts ref="chart6" :constructor-type="'mapChart'" :options="chartOptions6" class="mx-10 mt-10"
                    v-show="selectedChart === 'Sale' && selectedChartType === 'World'"></highcharts>

        <highcharts :constructor-type="'mapChart'" :options="chartOptions" class="mx-10 mt-10"
                    v-show="selectedChart === 'Orders' && selectedChartType === 'USA and Canada'"></highcharts>
        <highcharts :constructor-type="'mapChart'" :options="chartOptions2" class="mx-10 mt-10"
                    v-show="selectedChart === 'Gallons'&& selectedChartType === 'USA and Canada'"></highcharts>
        <highcharts :constructor-type="'mapChart'" :options="chartOptions3" class="mx-10 mt-10"
                    v-show="selectedChart === 'Sale'&& selectedChartType === 'USA and Canada'"></highcharts>
      </v-col>
    </v-row>
    <div v-if="selectedChartType === 'World'">
      <v-data-table
          :headers="headerCountry"
          :items="countryWorldCodes"
          item-key="name"
          :items-per-page="5"
          class="elevation-2 mt-5 table-main-container"
          fixed-header
          height="350"
          :search="search"
          :footer-props="{
          'items-per-page-options': [10, 25, 50, 75, 100, -1]
          }"
          :page.sync="pagination.page"
          @click:row="rowClick"
      >
        <template v-for="e in slotCounty" v-slot:[`item.${e.name}`]="{ item }">
          <div class="d-flex flex-column align-end align-md-center" :key="e.name">
            <div v-if="e.filter=='formatFloat' && (!e.redirect || item[`${e.name}`]==0)">
              {{ item[`${e.name}`] | formatFloat }}
            </div>
            <div v-if="e.filter=='formatPrice' && !e.redirect">${{ item[`${e.name}`] | formatPrice }}</div>
            <a v-if="item[`${e.name}`]>0 && e.redirect"
               @click="redirectToSalesReport(item)">{{ item[`${e.name}`] | formatFloat }}</a>

            <div v-if="item[`${e.name}Compare`] > 0 && isCompareFilter"
                 class="d-inline-flex compare-text green--text text--darken-3">
              <v-icon class="compare-icon" color="green darken-2">mdi-arrow-up-thick</v-icon>
              <span v-if="e.filter=='formatFloat'" class="ml-0">{{ item[`${e.name}Compare`] | formatFloat }}</span>
              <span v-if="e.filter=='formatPrice'" class="ml-0">{{ item[`${e.name}Compare`] | formatPrice }}</span>
            </div>
            <div v-if="item[`${e.name}Compare`] < 0 && isCompareFilter"
                 class="d-inline-flex compare-text red--text text--darken-3">
              <v-icon class="compare-icon" color="red darken-2">mdi-arrow-down-thick</v-icon>
              <span v-if="e.filter=='formatFloat'" class="ml-0">{{ item[`${e.name}Compare`] | formatFloatAbs }}</span>
              <span v-if="e.filter=='formatPrice'" class="ml-0">{{ item[`${e.name}Compare`] | formatPriceAbs }}</span>
            </div>
            <div v-if="item[`${e.name}Compare`] == 0 && isCompareFilter" class="compare-text blue--text text--darken-3">
              0
            </div>
          </div>
        </template>
      </v-data-table>
    </div>
    <div v-else>
      <v-card class="elevation-2 py-1 px-6 mt-4 rounded-lg">
        <v-row>
          <v-col cols="12" sm="4" md="3" lg="2">
            <v-select
                :items="locations"
                label="Select locations"
                v-model="location"
                outlined
                dense
                hide-details
            ></v-select>
          </v-col>
          <v-col cols="10" sm="6" md="5" class="pb-0 mb-3 mb-sm-0">
            <v-text-field
                dense
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
                outlined
            ></v-text-field>
            <v-spacer></v-spacer>
          </v-col>
          <v-btn
              color="#3F51B5"
              class="mt-3"
              dark
              depressed
              height='40'
              max-width='40'
              min-width='40'
              @click="cleanFilters"
          >
            <v-icon>
              mdi-autorenew
            </v-icon>
          </v-btn>
        </v-row>
      </v-card>
      <v-data-table
          v-if="location=='State'"
          :headers="headerStates"
          :items="stateNames"
          item-key="name"
          class="elevation-2 mt-5 table-main-container"
          fixed-header
          height="528"
          :search="search"
          :loading="loaded"
          :footer-props="{
        'items-per-page-options': [5, 10, 25, 50, 75, 100, -1]
        }"
          :page.sync="pagination.page"
          @click:row="rowClick"
      >
        <template v-for="e in slotCounty" v-slot:[`item.${e.name}`]="{ item }">
          <div class="d-flex flex-column align-end align-md-center" :key="e.name">
            <div v-if="e.filter=='formatFloat' && (!e.redirect || item[`${e.name}`]==0)">
              {{ item[`${e.name}`] | formatFloat }}
            </div>
            <div v-if="e.filter=='formatPrice' && !e.redirect">${{ item[`${e.name}`] | formatPrice }}</div>
            <a v-if="item[`${e.name}`]>0 && e.redirect"
               @click="redirectToSalesReport(item)">{{ item[`${e.name}`] | formatFloat }}</a>

            <div v-if="item[`${e.name}Compare`] > 0 && isCompareFilter"
                 class="d-inline-flex compare-text green--text text--darken-3">
              <v-icon class="compare-icon" color="green darken-2">mdi-arrow-up-thick</v-icon>
              <span v-if="e.filter=='formatFloat'" class="ml-0">{{ item[`${e.name}Compare`] | formatFloat }}</span>
              <span v-if="e.filter=='formatPrice'" class="ml-0">{{ item[`${e.name}Compare`] | formatPrice }}</span>
            </div>
            <div v-if="item[`${e.name}Compare`] < 0 && isCompareFilter"
                 class="d-inline-flex compare-text red--text text--darken-3">
              <v-icon class="compare-icon" color="red darken-2">mdi-arrow-down-thick</v-icon>
              <span v-if="e.filter=='formatFloat'" class="ml-0">{{ item[`${e.name}Compare`] | formatFloatAbs }}</span>
              <span v-if="e.filter=='formatPrice'" class="ml-0">{{ item[`${e.name}Compare`] | formatPriceAbs }}</span>
            </div>
            <div v-if="item[`${e.name}Compare`] == 0 && isCompareFilter" class="compare-text blue--text text--darken-3">
              0
            </div>
          </div>
        </template>
      </v-data-table>
      <v-data-table
          v-if="location=='City'"
          :headers="headerCities"
          :items="countyNames"
          item-key="name"
          :items-per-page="10"
          class="elevation-2 mt-5 table-main-container"
          fixed-header
          height="528"
          :search="search"
          :footer-props="{
          'items-per-page-options': [5, 10, 25, 50, 75, 100, -1]
          }"
          :page.sync="pagination.page"
          @click:row="rowClick"
      >
        <template v-for="e in slotCounty" v-slot:[`item.${e.name}`]="{ item }">
          <div class="d-flex flex-column align-end align-md-center" :key="e.name">
            <div v-if="e.filter=='formatFloat' && (!e.redirect || item[`${e.name}`]==0)">
              {{ item[`${e.name}`] | formatFloat }}
            </div>
            <div v-if="e.filter=='formatPrice' && !e.redirect">${{ item[`${e.name}`] | formatPrice }}</div>
            <a v-if="item[`${e.name}`]>0 && e.redirect"
               @click="redirectToSalesReport(item)">{{ item[`${e.name}`] | formatFloat }}</a>

            <div v-if="item[`${e.name}Compare`] > 0 && isCompareFilter"
                 class="d-inline-flex compare-text green--text text--darken-3">
              <v-icon class="compare-icon" color="green darken-2">mdi-arrow-up-thick</v-icon>
              <span v-if="e.filter=='formatFloat'" class="ml-0">{{ item[`${e.name}Compare`] | formatFloat }}</span>
              <span v-if="e.filter=='formatPrice'" class="ml-0">{{ item[`${e.name}Compare`] | formatPrice }}</span>
            </div>
            <div v-if="item[`${e.name}Compare`] < 0 && isCompareFilter"
                 class="d-inline-flex compare-text red--text text--darken-3">
              <v-icon class="compare-icon" color="red darken-2">mdi-arrow-down-thick</v-icon>
              <span v-if="e.filter=='formatFloat'" class="ml-0">{{ item[`${e.name}Compare`] | formatFloatAbs }}</span>
              <span v-if="e.filter=='formatPrice'" class="ml-0">{{ item[`${e.name}Compare`] | formatPriceAbs }}</span>
            </div>
            <div v-if="item[`${e.name}Compare`] == 0 && isCompareFilter" class="compare-text blue--text text--darken-3">
              0
            </div>
          </div>
        </template>
      </v-data-table>
      <v-data-table
          v-if="location=='Country'"
          :headers="headerCountry"
          :items="countryCodes"
          item-key="name"
          :items-per-page="5"
          class="elevation-2 mt-5 table-main-container"
          fixed-header
          height="144"
          :search="search"
          :footer-props="{
          'items-per-page-options': [10, 25, 50, 75, 100, -1]
          }"
          :page.sync="pagination.page"
          @click:row="rowClick"
      >
        <template v-for="e in slotCounty" v-slot:[`item.${e.name}`]="{ item }">
          <div class="d-flex flex-column align-end align-md-center" :key="e.name">
            <div v-if="e.filter=='formatFloat' && (!e.redirect || item[`${e.name}`]==0)">
              {{ item[`${e.name}`] | formatFloat }}
            </div>
            <div v-if="e.filter=='formatPrice' && !e.redirect">${{ item[`${e.name}`] | formatPrice }}</div>
            <a v-if="item[`${e.name}`]>0 && e.redirect"
               @click="redirectToSalesReport(item)">{{ item[`${e.name}`] | formatFloat }}</a>

            <div v-if="item[`${e.name}Compare`] > 0 && isCompareFilter"
                 class="d-inline-flex compare-text green--text text--darken-3">
              <v-icon class="compare-icon" color="green darken-2">mdi-arrow-up-thick</v-icon>
              <span v-if="e.filter=='formatFloat'" class="ml-0">{{ item[`${e.name}Compare`] | formatFloat }}</span>
              <span v-if="e.filter=='formatPrice'" class="ml-0">{{ item[`${e.name}Compare`] | formatPrice }}</span>
            </div>
            <div v-if="item[`${e.name}Compare`] < 0 && isCompareFilter"
                 class="d-inline-flex compare-text red--text text--darken-3">
              <v-icon class="compare-icon" color="red darken-2">mdi-arrow-down-thick</v-icon>
              <span v-if="e.filter=='formatFloat'" class="ml-0">{{ item[`${e.name}Compare`] | formatFloatAbs }}</span>
              <span v-if="e.filter=='formatPrice'" class="ml-0">{{ item[`${e.name}Compare`] | formatPriceAbs }}</span>
            </div>
            <div v-if="item[`${e.name}Compare`] == 0 && isCompareFilter" class="compare-text blue--text text--darken-3">
              0
            </div>
          </div>
        </template>
      </v-data-table>
    </div>
  </v-container>
</template>

<script>
import axios from '@/api/axios-auth'
import RangeFilter from '@/components/filters/RangePicker'
import {Chart} from 'highcharts-vue'
import {codes} from '@/utils/stateCodes'
import LastTimeUpdated from "@/views/LastTimeUpdated";
//import { extend } from 'vue/types/umd'
import CompareFilter from '@/components/filters/ComparePicker'
import moment from "moment";

export default {
  components: {
    LastTimeUpdated,
    RangeFilter,
    highcharts: Chart,
    CompareFilter
  },
  data() {
    return {
      isCompareFilter: false,
      compareIcon: 'mdi-compare-vertical',
      dateCompareEnd: new Date(
          Date.UTC(
              new Date().getFullYear(),
              new Date().getMonth(),
              0
          )).toISOString().substr(0, 10),
      dateCompareStart: new Date(
          Date.UTC(
              new Date().getFullYear(),
              new Date().getMonth() - 1,
              0
          )).toISOString().substr(0, 10),
      diffDays: 0,
      compareFilterColor: 'orange darken-3',
      defaultComparePeriod: 5,
      dataCompare: [],
      dataCountyCmp: [],

      slotCounty: [
        {name: 'orders', filter: 'formatFloat', redirect: true},
        {name: 'gallons', filter: 'formatFloat'},
        {name: 'price', filter: 'formatPrice'},
      ],

      charts: ['Orders', 'Gallons', 'Sale'],
      selectedChart: 'Orders',
      chartsType: ['World', 'USA and Canada'],
      selectedChartType: 'USA and Canada',
      showAllAreas: true,
      filtered: {
        'products': [],
      },
      filters: {
        'productName': []
      },
      dateEnd: new Date().toISOString().substr(0, 10),
      dateStart: new Date(
          Date.UTC(
              new Date().getFullYear(),
              new Date().getMonth(),
              1)).toISOString().substr(0, 10),
      excludePeriod: [],
      defaultPeriod: 4,
      pagination: {
        page: 1
      },
      headerStates: [
        {text: 'State', value: 'name', class: 'black--text'},
        {text: 'Country', value: 'country', class: 'black--text'},
        {text: 'Total Orders', value: 'orders', class: 'black--text'},
        {text: 'Total Gallons', value: 'gallons', class: 'black--text'},
        {text: 'Sale', value: 'price', class: 'black--text'}
      ],
      headerCities: [
        {text: 'City', value: 'name', class: 'black--text'},
        {text: 'State', value: 'state', class: 'black--text'},
        {text: 'Country', value: 'country', class: 'black--text'},
        {text: 'Total Orders', value: 'orders', class: 'black--text'},
        {text: 'Total Gallons', value: 'gallons', class: 'black--text'},
        {text: 'Sale', value: 'price', class: 'black--text'}
      ],
      headerCountry: [
        {text: 'Country', value: 'name', class: 'black--text'},
        {text: 'Total Orders', value: 'orders', class: 'black--text'},
        {text: 'Total Gallons', value: 'gallons', class: 'black--text'},
        {text: 'Sale', value: 'price', class: 'black--text'}
      ],
      search: '',
      loaded: false,
      data: [],
      dataCounty: [],
      countyNames: [],
      stateNames: [],
      countryCodes: [],
      countryWorldCodes: [],
      markers: [],
      allStates: [],
      totalOrdersChartData: [],
      salePriceChartData: [],
      gallonsChartData: [],
      locations: ['State', 'City', 'Country'],
      location: 'State',
      chartOptions: {
        credits: {
          enabled: false
        },
        xAxis: {
          align: 'left'
        },
        chart: {
          map: 'geoSalesReport',
          height: 700,
          events: {
            load() {
              this.mapZoom(0.7)
            },
          }
        },
        title: {
          text: null,
          style: {"color": "#333333", "fontSize": "18px", "fontWeight": 'bold'}
        },
        mapNavigation: {
          enableMouseWheelZoom:false,
          enabled: true,
          buttonOptions: {
            alignTo: 'spacingBox'
          }
        },
        colorAxis: {
          min: 0
        },
        legend: {
          layout: 'vertical',
          align: 'left',
          verticalAlign: 'bottom',
          reversed: true
        },
        tooltip: {
          formatter(tooltip) {

            let point = this,
                total_gallons = 0,
                total_sales_price = 0

            if (tooltip.chart.userOptions.gallonsChartData) {
              let totalGallons = tooltip.chart.userOptions.gallonsChartData

              totalGallons.forEach(d => {
                if (d[0] == point.point['hc-key']) {
                  total_gallons = d[1]
                }
              })
            }

            if (tooltip.chart.userOptions.salePriceChartData) {
              let totalPrice = tooltip.chart.userOptions.salePriceChartData

              totalPrice.forEach(d => {
                if (d[0] == point.point['hc-key']) {
                  total_sales_price = d[1]
                }
              })
            }

            return `<b>${this.point.name}</b><br/>
                    Total Orders: ${this.point.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}<br/>
                    Total Gallons: ${total_gallons.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}<br/>
                    Sale: $${total_sales_price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                    `
          }
        },
        plotOptions: {
          series: {
            events: {
              click: (e) => {
                let order_ids = []

                if (this.chartOptions.orderIdsChartData) {
                  let orderIds = this.chartOptions.orderIdsChartData

                  orderIds.forEach(d => {
                    if (d[0] == e.point['hc-key']) {
                      order_ids = d[1]
                    }
                  })
                }

                let orders = JSON.stringify({
                  report: 'geoSalesReport',
                  order_ids: order_ids,
                  dateStart: this.dateStart,
                  dateEnd: this.dateEnd,
                  defaultPeriod: this.defaultPeriod
                })
                localStorage.setItem('orders', orders)

                let routeData = this.$router.resolve({name: 'sales'})
                window.open(routeData.href, '_blank')
              }
            }
          }
        },
        series: [{
          name: 'Total Orders',
          states: {
            hover: {
              color: '#BADA55'
            }
          },
          dataLabels: {
            enabled: true,
            format: '{point.name}'
          },
          allAreas: false,
          yAxis: 0,
          data: codes
        }],
      },
      chartOptions2: {
        credits: {
          enabled: false
        },
        xAxis: {
          align: 'left'
        },
        chart: {
          map: 'geoSalesReport',
          height: 700,
          events: {
            load() {
              this.mapZoom(0.7)
            },
          }
        },
        title: {
          text: null,
          style: {"color": "#333333", "fontSize": "18px", "fontWeight": 'bold'}
        },
        mapNavigation: {
          enableMouseWheelZoom:false,
          enabled: true,
          buttonOptions: {
            alignTo: 'spacingBox'
          }
        },
        colorAxis: {
          min: 0
        },
        legend: {
          layout: 'vertical',
          align: 'left',
          verticalAlign: 'bottom',
          reversed: true
        },
        tooltip: {
          formatter(tooltip) {

            let point = this,
                total_orders = 0,
                total_sales_price = 0


            if (tooltip.chart.userOptions.totalOrdersChartData) {
              let totalOrders = tooltip.chart.userOptions.totalOrdersChartData
              totalOrders.forEach(d => {
                if (d[0] == point.point['hc-key']) {
                  total_orders = d[1]
                }
              })
            }

            if (tooltip.chart.userOptions.salePriceChartData) {
              let totalPrice = tooltip.chart.userOptions.salePriceChartData

              totalPrice.forEach(d => {
                if (d[0] == point.point['hc-key']) {
                  total_sales_price = d[1]
                }
              })
            }

            return `<b>${this.point.name}</b><br/>
                       Total Gallons: ${this.point.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}<br/> 
                       Total Orders: ${total_orders.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}<br/>        
                       Sale: $${total_sales_price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
          }
        },
        plotOptions: {
          series: {
            events: {
              click: (e) => {
                let order_ids = []

                if (this.chartOptions.orderIdsChartData) {
                  let orderIds = this.chartOptions.orderIdsChartData

                  orderIds.forEach(d => {
                    if (d[0] == e.point['hc-key']) {
                      order_ids = d[1]
                    }
                  })
                }

                let orders = JSON.stringify({
                  report: 'geoSalesReport',
                  order_ids: order_ids,
                  dateStart: this.dateStart,
                  dateEnd: this.dateEnd,
                  defaultPeriod: this.defaultPeriod
                })
                localStorage.setItem('orders', orders)

                let routeData = this.$router.resolve({name: 'sales'})
                window.open(routeData.href, '_blank')
              }
            }
          }
        },
        series: [{
          name: 'Total Gallons',
          states: {
            hover: {
              color: '#BADA55'
            }
          },
          dataLabels: {
            enabled: true,
            format: '{point.name}'
          },
          allAreas: false,
          yAxis: 0,
          data: codes
        }],
      },
      chartOptions3: {
        credits: {
          enabled: false
        },
        xAxis: {
          align: 'left'
        },
        chart: {
          map: 'geoSalesReport',
          height: 700,
          events: {
            load() {
              this.mapZoom(0.7)
            },
          }
        },
        title: {
          text: null,
          style: {"color": "#333333", "fontSize": "18px", "fontWeight": 'bold'}
        },
        mapNavigation: {
          enableMouseWheelZoom:false,
          enabled: true,
          buttonOptions: {
            alignTo: 'spacingBox'
          }
        },
        colorAxis: {
          min: 0
        },
        legend: {
          layout: 'vertical',
          align: 'left',
          verticalAlign: 'bottom',
          reversed: true
        },
        tooltip: {
          formatter(tooltip) {

            let point = this,
                total_orders = 0,
                total_gallons = 0

            if (tooltip.chart.userOptions.totalOrdersChartData) {
              let totalOrders = tooltip.chart.userOptions.totalOrdersChartData

              totalOrders.forEach(d => {
                if (d[0] == point.point['hc-key']) {
                  total_orders = d[1]
                }
              })
            }

            if (tooltip.chart.userOptions.gallonsChartData) {
              let totalGallons = tooltip.chart.userOptions.gallonsChartData

              totalGallons.forEach(d => {
                if (d[0] == point.point['hc-key']) {
                  total_gallons = d[1]
                }
              })
            }

            return `<b>${this.point.name}</b><br/>
                      Sale: $${this.point.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}<br/>
                      Total Orders: ${total_orders.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}<br/>
                      Total Gallons: ${total_gallons.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}<br/>`
          }
        },
        plotOptions: {
          series: {
            events: {
              click: (e) => {
                let order_ids = []

                if (this.chartOptions.orderIdsChartData) {
                  let orderIds = this.chartOptions.orderIdsChartData

                  orderIds.forEach(d => {
                    if (d[0] == e.point['hc-key']) {
                      order_ids = d[1]
                    }
                  })
                }

                let orders = JSON.stringify({
                  report: 'geoSalesReport',
                  order_ids: order_ids,
                  dateStart: this.dateStart,
                  dateEnd: this.dateEnd,
                  defaultPeriod: this.defaultPeriod
                })
                localStorage.setItem('orders', orders)

                let routeData = this.$router.resolve({name: 'sales'})
                window.open(routeData.href, '_blank')
              }
            }
          }
        },
        series: [{
          name: 'Sale',
          states: {
            hover: {
              color: '#BADA55'
            }
          },
          dataLabels: {
            enabled: true,
            format: '{point.name}'
          },
          allAreas: false,
          yAxis: 0,
          data: codes
        }],
      },
      chartOptions4: {
        credits: {
          enabled: false
        },
        xAxis: {
          align: 'left'
        },
        chart: {
          map: 'geoSalesReportWorld',
          height: 700,
          events: {
            load() {
              this.mapZoom(1)
            },
          }
        },
        title: {
          text: null,
          style: {"color": "#333333", "fontSize": "18px", "fontWeight": 'bold'}
        },
        mapNavigation: {
          enableMouseWheelZoom:false,
          enabled: true,
          buttonOptions: {
            alignTo: 'spacingBox'
          }
        },
        colorAxis: {
          min: 0
        },
        legend: {
          layout: 'vertical',
          align: 'left',
          verticalAlign: 'bottom',
          reversed: true
        },
        tooltip: {
          formatter(tooltip) {

            let point = this,
                total_gallons = 0,
                total_sales_price = 0

            if (tooltip.chart.userOptions.gallonsChartData) {
              let totalGallons = tooltip.chart.userOptions.gallonsChartData

              totalGallons.forEach(d => {
                if (d["code"] == point.point['code']) {
                  total_gallons = d["value"]
                }
              })
            }

            if (tooltip.chart.userOptions.salePriceChartData) {
              let totalPrice = tooltip.chart.userOptions.salePriceChartData

              totalPrice.forEach(d => {
                if (d["code"] == point.point['code']) {
                  total_sales_price = d["value"]
                }
              })
            }

            return `<b>${this.point.name}</b><br/>
                    Total Orders: ${this.point.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}<br/>
                    Total Gallons: ${total_gallons.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}<br/>
                    Sale: $${total_sales_price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                    `
          }
        },
        plotOptions: {
          series: {
            events: {
              click: (e) => {
                let order_ids = []

                if (this.chartOptions4.orderIdsChartData) {
                  let orderIds = this.chartOptions4.orderIdsChartData

                  orderIds.forEach(d => {
                    if (d['code'] == e.point['code']) {
                      order_ids = d["value"]
                    }
                  })
                }

                let orders = JSON.stringify({
                  report: 'geoSalesReport',
                  order_ids: order_ids,
                  dateStart: this.dateStart,
                  dateEnd: this.dateEnd,
                  defaultPeriod: this.defaultPeriod
                })
                localStorage.setItem('orders', orders)

                let routeData = this.$router.resolve({name: 'sales'})
                window.open(routeData.href, '_blank')
              }
            }
          }
        },
        series: [{
          name: 'Total Orders',
          states: {
            hover: {
              color: '#BADA55'
            }
          },
          dataLabels: {
            enabled: true,
            format: '{point.name}'
          },
          allAreas: true,
          yAxis: 0,
          joinBy: ['iso-a2', 'code'],
          data: null
        }],
      },
      chartOptions5: {
        credits: {
          enabled: false
        },
        xAxis: {
          align: 'left'
        },
        chart: {
          map: 'geoSalesReportWorld',
          height: 700,
          events: {
            load() {
              this.mapZoom(1)
            },
          }
        },
        title: {
          text: null,
          style: {"color": "#333333", "fontSize": "18px", "fontWeight": 'bold'}
        },
        mapNavigation: {
          enableMouseWheelZoom:false,
          enabled: true,
          buttonOptions: {
            alignTo: 'spacingBox'
          }
        },
        colorAxis: {
          min: 0
        },
        legend: {
          layout: 'vertical',
          align: 'left',
          verticalAlign: 'bottom',
          reversed: true
        },
        tooltip: {
          formatter(tooltip) {

            let point = this,
                total_orders = 0,
                total_sales_price = 0


            if (tooltip.chart.userOptions.totalOrdersChartData) {
              let totalOrders = tooltip.chart.userOptions.totalOrdersChartData
              totalOrders.forEach(d => {
                if (d['code'] == point.point['code']) {
                  total_orders = d['value']
                }
              })
            }

            if (tooltip.chart.userOptions.salePriceChartData) {
              let totalPrice = tooltip.chart.userOptions.salePriceChartData

              totalPrice.forEach(d => {
                if (d['code'] == point.point['code']) {
                  total_sales_price = d['value']
                }
              })
            }

            return `<b>${this.point.name}</b><br/>
                       Total Gallons: ${this.point.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}<br/>
                       Total Orders: ${total_orders.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}<br/>
                       Sale: $${total_sales_price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
          }
        },
        plotOptions: {
          series: {
            events: {
              click: (e) => {
                let order_ids = []

                if (this.chartOptions5.orderIdsChartData) {
                  let orderIds = this.chartOptions5.orderIdsChartData

                  orderIds.forEach(d => {
                    if (d['code'] == e.point['code']) {
                      order_ids = d['value']
                    }
                  })
                }

                let orders = JSON.stringify({
                  report: 'geoSalesReport',
                  order_ids: order_ids,
                  dateStart: this.dateStart,
                  dateEnd: this.dateEnd,
                  defaultPeriod: this.defaultPeriod
                })
                localStorage.setItem('orders', orders)

                let routeData = this.$router.resolve({name: 'sales'})
                window.open(routeData.href, '_blank')
              }
            }
          }
        },
        series: [{
          name: 'Total Gallons',
          states: {
            hover: {
              color: '#BADA55'
            }
          },
          dataLabels: {
            enabled: true,
            format: '{point.name}'
          },
          allAreas: true,
          yAxis: 0,
          joinBy: ['iso-a2', 'code'],
          data: []
        }],
      },
      chartOptions6: {
        credits: {
          enabled: false
        },
        xAxis: {
          align: 'left'
        },
        chart: {
          map: 'geoSalesReportWorld',
          height: 700,
          events: {
            load() {
              this.mapZoom(1)
            },
          }
        },
        title: {
          text: null,
          style: {"color": "#333333", "fontSize": "18px", "fontWeight": 'bold'}
        },
        mapNavigation: {
          enableMouseWheelZoom:false,
          enabled: true,
          buttonOptions: {
            alignTo: 'spacingBox'
          }
        },
        colorAxis: {
          min: 0
        },
        legend: {
          layout: 'vertical',
          align: 'left',
          verticalAlign: 'bottom',
          reversed: true
        },
        tooltip: {
          formatter(tooltip) {

            let point = this,
                total_orders = 0,
                total_gallons = 0

            if (tooltip.chart.userOptions.totalOrdersChartData) {
              let totalOrders = tooltip.chart.userOptions.totalOrdersChartData

              totalOrders.forEach(d => {
                if (d['code'] == point.point['code']) {
                  total_orders = d['value']
                }
              })
            }

            if (tooltip.chart.userOptions.gallonsChartData) {
              let totalGallons = tooltip.chart.userOptions.gallonsChartData

              totalGallons.forEach(d => {
                if (d['code'] == point.point['code']) {
                  total_gallons = d['value']
                }
              })
            }

            return `<b>${this.point.name}</b><br/>
                      Sale: $${this.point.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}<br/>
                      Total Orders: ${total_orders.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}<br/>
                      Total Gallons: ${total_gallons.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}<br/>`
          }
        },
        plotOptions: {
          series: {
            events: {
              click: (e) => {
                let order_ids = []

                if (this.chartOptions6.orderIdsChartData) {
                  let orderIds = this.chartOptions6.orderIdsChartData

                  orderIds.forEach(d => {
                    if (d['code'] == e.point['code']) {
                      order_ids = d['value']
                    }
                  })
                }

                let orders = JSON.stringify({
                  report: 'geoSalesReport',
                  order_ids: order_ids,
                  dateStart: this.dateStart,
                  dateEnd: this.dateEnd,
                  defaultPeriod: this.defaultPeriod
                })
                localStorage.setItem('orders', orders)

                let routeData = this.$router.resolve({name: 'sales'})
                window.open(routeData.href, '_blank')
              }
            }
          }
        },
        series: [{
          name: 'Sale',
          states: {
            hover: {
              color: '#BADA55'
            }
          },
          dataLabels: {
            enabled: true,
            format: '{point.name}'
          },
          allAreas: true,
          yAxis: 0,
          joinBy: ['iso-a2', 'code'],
          data: []
        }],
      },
    }
  },
  computed: {
    dataFiltered() {
      return this.data.filter(d => {
        return Object.keys(this.filtered).every(f => {
          if (Array.isArray(d[f])) { // custom filter for product type
            let names = this._.map(d[f], p => {
              return p.name
            })
            for (let n of names) {
              if (this.filtered[f].includes(n)) {
                return this.filtered[f].length < 1 || this.filtered[f].includes(n)
              }
            }
          }
          return this.filtered[f].length < 1 || this.filtered[f].includes(d[f])
        })
      })
    },
    dataFilteredCmp() {
      return this.dataCompare.filter(d => {
        return Object.keys(this.filtered).every(f => {
          if (Array.isArray(d[f])) { // custom filter for product type
            let names = this._.map(d[f], p => {
              return p.name
            })
            for (let n of names) {
              if (this.filtered[f].includes(n)) {
                return this.filtered[f].length < 1 || this.filtered[f].includes(n)
              }
            }
          }
          return this.filtered[f].length < 1 || this.filtered[f].includes(d[f])
        })
      })
    },
    dataWorldFilteredCmp() {
      return this.dataCountyCmp.filter(d => {
        return Object.keys(this.filtered).every(f => {
          if (Array.isArray(d[f])) { // custom filter for product type
            let names = this._.map(d[f], p => {
              return p.name
            })
            for (let n of names) {
              if (this.filtered[f].includes(n)) {
                return this.filtered[f].length < 1 || this.filtered[f].includes(n)
              }
            }
          }
          return this.filtered[f].length < 1 || this.filtered[f].includes(d[f])
        })
      })
    },
    dataWorldFiltered() {
      return this.dataCounty.filter(d => {
        return Object.keys(this.filtered).every(f => {
          if (Array.isArray(d[f])) { // custom filter for product type
            let names = this._.map(d[f], p => {
              return p.name
            })
            for (let n of names) {
              if (this.filtered[f].includes(n)) {
                return this.filtered[f].length < 1 || this.filtered[f].includes(n)
              }
            }
          }
          return this.filtered[f].length < 1 || this.filtered[f].includes(d[f])
        })
      })
    },
  },
  watch: {
    dateStart() {
      this.countDiffDayes()
      this.countDateCompareEnd()
      this.countDateCompareStart()
    },
    dateEnd() {
      this.countDiffDayes()
      this.countDateCompareEnd()
      this.countDateCompareStart()
    },
    isCompareFilter() {
      if (!this.isCompareFilter) {
        let d = moment(this.dateStart)
        this.dateCompareEnd = new Date(Date.UTC(
            new Date(d).getFullYear(),
            new Date(d).getMonth(),
            new Date(d).getDate() - 1)
        ).toISOString().substr(0, 10)

        this.dateCompareStart = new Date(
            Date.UTC(
                new Date(d).getFullYear(),
                new Date(d).getMonth(),
                new Date(d).getDate() - this.diffDays)
        ).toISOString().substr(0, 10)
      } else {
        this.applayCompares()
      }
    },
    dataFiltered: function () {
      this.getGroup()
    },
    selectedChart() {
      this.pagination.page = 1
    },
    stateNames() {
      this.pagination.page = 1
    },
    countyNames() {
      this.pagination.page = 1
    },
    countryCodes() {
      this.pagination.page = 1
    },
    countryWorldCodes() {
      this.pagination.page = 1
    },
    // chart component have a bug
    showAllAreas(val) {
      this.$nextTick(() => {
        this.chartOptions4.series[0].allAreas = val
        this.getGroup()
      })
    }
  },
  mounted() {
    if (sessionStorage.getItem('dateStart')) {
      this.dateStart = sessionStorage.getItem('dateStart')
    }
    if (sessionStorage.getItem('dateEnd')) {
      this.dateEnd = sessionStorage.getItem('dateEnd')
    }

    this.applyFilters()
    this.countDiffDayes()
  },
  created() {
    this.countDiffDayes()
    this.countDateCompareEnd()
    this.countDateCompareStart()
  },
  methods: {
    countDateCompareEnd() {
      let d = moment(this.dateStart)

      this.dateCompareEnd = new Date(
          Date.UTC(
              new Date(d).getFullYear(),
              new Date(d).getMonth(),
              new Date(d).getDate() - 1)
      ).toISOString().substr(0, 10)
    },
    countDateCompareStart() {
      let d = moment(this.dateStart)

      this.dateCompareStart = new Date(
          Date.UTC(
              new Date(d).getFullYear(),
              new Date(d).getMonth(),
              new Date(d).getDate() - this.diffDays)
      ).toISOString().substr(0, 10)
    },
    countDiffDayes() {
      const oneDay = 24 * 60 * 60 * 1000
      const firstDate = new Date(this.dateStart)
      const secondDate = new Date(this.dateEnd)

      this.diffDays = Math.round(Math.abs((firstDate - secondDate) / oneDay)) + 1
    },
    getCompareDates(dates) {
      this.dateCompareStart = dates.dateStart
      this.dateCompareEnd = dates.dateEnd
      this.applayCompares()
    },
    applayCompares() {
      this.loaded = true
      axios
          .get('/reports/marketing/geo-sale-report/' + this.dateCompareStart + '/' + this.dateCompareEnd)
          .then(response => {
            this.dataCompare = response.data.data
            this.dataCountyCmp = response.data.by_county
            this.getGroup()
            this.loaded = false
          })
    },
    getDates(dates) {
      this.dateStart = dates.dateStart
      this.dateEnd = dates.dateEnd
      this.pagination.page = 1
      this.applyFilters()
    },
    applyFilters() {
      this.loaded = true
      axios
          .get('/reports/marketing/geo-sale-report/' + this.dateStart + '/' + this.dateEnd)
          .then(response => {

            this.data = response.data.data
            this.dataCounty = response.data.by_county
            this.loaded = false

            this.filters.productName = []
            for (let d of this.data) {
              for (let p of d.products) {
                this.filters.productName.push(p.name)
              }
            }

            this.filters.productName = this._.union(this.filters.productName)
            this.getGroup()
          })
    },
    getGroup() {
      this.markers = this.dataFiltered.map(m => ({
        latLng: {
          lat: m.latitude,
          lng: m.longitude,
        }
      }))

      this.countyNames = this._.chain(this.dataFiltered)
          .groupBy("place_name")
          .map((value, key) => ({
            name: key,
            state: value[0].state_name,
            country: value[0].country_code,
            orders: value.length,
            price: Number((value.reduce((acc, e) => acc + e.sale_price, 0)).toFixed(2)),
            gallons: value.reduce((acc, e) => acc + e.gallons, 0),
            order_ids: value.reduce((acc, e) => [...acc, e.id], [])
          }))
          .value()

      this.countyNamesCmp = this._.chain(this.dataFilteredCmp)
          .groupBy("place_name")
          .map((value, key) => ({
            name: key,
            state: value[0].state_name,
            country: value[0].country_code,
            orders: value.length,
            price: Number((value.reduce((acc, e) => acc + e.sale_price, 0)).toFixed(2)),
            gallons: value.reduce((acc, e) => acc + e.gallons, 0),
            order_ids: value.reduce((acc, e) => [...acc, e.id], [])
          }))
          .value()

      this.countyNames.map(e => {
        let obj = this.countyNamesCmp.find(i => i.name === e.name)
        if (obj) {
          e.ordersCompare = e.orders - obj.orders
          e.priceCompare = e.price - obj.price
          e.gallonsCompare = e.gallons - obj.gallons
        }
      })

      this.countyNames = this._.orderBy(this.countyNames, 'count', 'desc');

      this.stateNames = this._.chain(this.dataFiltered)
          .groupBy("state_name")
          .map((value, key) => ({
            name: key,
            country: value[0].country_code,
            orders: value.length,
            price: Number((value.reduce((acc, e) => acc + e.sale_price, 0)).toFixed(2)),
            gallons: value.reduce((acc, e) => acc + e.gallons, 0),
            order_ids: value.reduce((acc, e) => [...acc, e.id], []),
            state_code: `${value[0].country_code.toLowerCase()}-${value[0].state_code.toLowerCase()}`
          }))
          .value()

      this.stateNamesCmp = this._.chain(this.dataFilteredCmp)
          .groupBy("state_name")
          .map((value, key) => ({
            name: key,
            country: value[0].country_code,
            orders: value.length,
            price: Number((value.reduce((acc, e) => acc + e.sale_price, 0)).toFixed(2)),
            gallons: value.reduce((acc, e) => acc + e.gallons, 0),
            order_ids: value.reduce((acc, e) => [...acc, e.id], []),
            state_code: `${value[0].country_code.toLowerCase()}-${value[0].state_code.toLowerCase()}`
          }))
          .value()

      this.stateNames.map(e => {
        let obj = this.stateNamesCmp.find(i => i.name === e.name)
        if (obj) {
          e.ordersCompare = e.orders - obj.orders
          e.priceCompare = e.price - obj.price
          e.gallonsCompare = e.gallons - obj.gallons
        }
      })

      this.stateNames = this._.orderBy(this.stateNames, 'orders', 'desc');

      this.countryCodes = this._.chain(this.dataFiltered)
          .groupBy("country_code")
          .map((value, key) => ({
            name: key,
            orders: value.length,
            price: Number((value.reduce((acc, e) => acc + e.sale_price, 0)).toFixed(2)),
            gallons: value.reduce((acc, e) => acc + e.gallons, 0),
            order_ids: value.reduce((acc, e) => [...acc, e.id], []),
          }))
          .value()

      this.countryCodesCmp = this._.chain(this.dataFilteredCmp)
          .groupBy("country_code")
          .map((value, key) => ({
            name: key,
            orders: value.length,
            price: Number((value.reduce((acc, e) => acc + e.sale_price, 0)).toFixed(2)),
            gallons: value.reduce((acc, e) => acc + e.gallons, 0),
            order_ids: value.reduce((acc, e) => [...acc, e.id], []),
          }))
          .value()

      this.countryCodes.map(e => {
        let obj = this.countryCodesCmp.find(i => i.name === e.name)
        if (obj) {
          e.ordersCompare = e.orders - obj.orders
          e.priceCompare = e.price - obj.price
          e.gallonsCompare = e.gallons - obj.gallons
        }
      })

      this.countryCodes = this._.orderBy(this.countryCodes, 'count', 'desc')

      this.countryWorldCodes = this._.chain(this.dataWorldFiltered)
          .groupBy("county")
          .map((value, key) => ({
            name: key,
            orders: value.length,
            price: Number((value.reduce((acc, e) => acc + e.sale_price, 0)).toFixed(2)),
            gallons: value.reduce((acc, e) => acc + e.gallons, 0),
            order_ids: value.reduce((acc, e) => [...acc, e.id], []),
          }))
          .value()

      this.countryWorldCodesCmp = this._.chain(this.dataWorldFilteredCmp)
          .groupBy("county")
          .map((value, key) => ({
            name: key,
            orders: value.length,
            price: Number((value.reduce((acc, e) => acc + e.sale_price, 0)).toFixed(2)),
            gallons: value.reduce((acc, e) => acc + e.gallons, 0),
            order_ids: value.reduce((acc, e) => [...acc, e.id], []),
          }))
          .value()

      this.countryWorldCodes.map(e => {
        let obj = this.countryWorldCodesCmp.find(i => i.name === e.name)
        if (obj) {
          e.ordersCompare = e.orders - obj.orders
          e.priceCompare = e.price - obj.price
          e.gallonsCompare = e.gallons - obj.gallons
        }
      })

      this.countryWorldCodes = this._.orderBy(this.countryWorldCodes, 'orders', 'desc')

      let emptyData = codes
      this.allStates = []

      if (this.dataFiltered.length > 0) {
        this.dataFiltered.map(e => {
          let elem = (e.country_code == "US") ? [`us-${e.state_code.toLowerCase()}`] : [`ca-${e.state_code.toLowerCase()}`]
          this.allStates.push({"state": elem})
        })

        this.totalOrdersChartData = this._.chain(this.allStates)
            .groupBy("state")
            .map((value, key) => [key, value.length])
            .value()

        this.chartOptions4.salePriceChartData = this._.chain(this.dataWorldFiltered)
            .groupBy("code")
            .map((value, key) => ({
              name: key,
              price: Number((value.reduce((acc, e) => acc + e.sale_price, 0)).toFixed(2))
            }))
            .value()
            .map(e => {
              return {code: e.name, value: e.price}
            })

        this.chartOptions4.gallonsChartData = this._.chain(this.dataWorldFiltered)
            .groupBy("code")
            .map((value, key) => ({
              name: key,
              gallons: Number((value.reduce((acc, e) => acc + e.gallons, 0)).toFixed(2))
            }))
            .value()
            .map(e => {
              return {code: e.name, value: e.gallons}
            })

        this.chartOptions4.orderIdsChartData = this._.chain(this.dataWorldFiltered)
            .groupBy("code")
            .map((value, key) => ({name: key, order_ids: value.reduce((acc, e) => [...acc, e.id], [])}))
            .value()
            .map(e => {
              return {code: e.name, value: e.order_ids}
            })

        this.chartOptions4.totalOrdersChartData = this._.chain(this.dataWorldFiltered)
            .groupBy("code")
            .map((value, key) => ({name: key, order_ids: value.reduce((acc, e) => [...acc, e.id], [])}))
            .value()
            .map(e => {
              return {code: e.name, value: e.order_ids.length}
            })

        this.chartOptions5.salePriceChartData = this.chartOptions4.salePriceChartData
        this.chartOptions5.gallonsChartData = this.chartOptions4.gallonsChartData
        this.chartOptions5.orderIdsChartData = this.chartOptions4.orderIdsChartData
        this.chartOptions5.totalOrdersChartData = this.chartOptions4.totalOrdersChartData

        this.chartOptions6.salePriceChartData = this.chartOptions4.salePriceChartData
        this.chartOptions6.gallonsChartData = this.chartOptions4.gallonsChartData
        this.chartOptions6.orderIdsChartData = this.chartOptions4.orderIdsChartData
        this.chartOptions6.totalOrdersChartData = this.chartOptions4.totalOrdersChartData

        this.chartOptions4.series[0].data = this.chartOptions4.totalOrdersChartData
        this.chartOptions5.series[0].data = this.chartOptions5.gallonsChartData
        this.chartOptions6.series[0].data = this.chartOptions6.salePriceChartData

        this.chartOptions.salePriceChartData = this._.chain(this.dataFiltered)
            .groupBy("state_code")
            .map((value, key) => ({
              name: key,
              code: value[0].country_code,
              price: Number((value.reduce((acc, e) => acc + e.sale_price, 0)).toFixed(2))
            }))
            .value()
            .map(e => (e.code == "US") ? [`us-${e.name.toLowerCase()}`, e.price] : [`ca-${e.name.toLowerCase()}`, e.price])

        this.chartOptions.gallonsChartData = this._.chain(this.dataFiltered)
            .groupBy("state_code")
            .map((value, key) => ({
              name: key,
              code: value[0].country_code,
              gallons: value.reduce((acc, e) => acc + e.gallons, 0)
            }))
            .value()
            .map(e => (e.code == "US") ? [`us-${e.name.toLowerCase()}`, e.gallons] : [`ca-${e.name.toLowerCase()}`, e.gallons])

        this.chartOptions.orderIdsChartData = this._.chain(this.dataFiltered)
            .groupBy("state_code")
            .map((value, key) => ({
              name: key,
              code: value[0].country_code,
              order_ids: value.reduce((acc, e) => [...acc, e.id], [])
            }))
            .value()
            .map(e => (e.code == "US") ? [`us-${e.name.toLowerCase()}`, e.order_ids] : [`ca-${e.name.toLowerCase()}`, e.order_ids])

        this.chartOptions2.salePriceChartData = this._.chain(this.dataFiltered)
            .groupBy("state_code")
            .map((value, key) => ({
              name: key,
              code: value[0].country_code,
              price: Number((value.reduce((acc, e) => acc + e.sale_price, 0)).toFixed(2))
            }))
            .value()
            .map(e => (e.code == "US") ? [`us-${e.name.toLowerCase()}`, e.price] : [`ca-${e.name.toLowerCase()}`, e.price])

        this.chartOptions2.totalOrdersChartData = this._.chain(this.dataFiltered)
            .groupBy("state_code")
            .map((value, key) => ({name: key, code: value[0].country_code, orders: value.length}))
            .value()
            .map(e => (e.code == "US") ? [`us-${e.name.toLowerCase()}`, e.orders] : [`ca-${e.name.toLowerCase()}`, e.orders])

        this.chartOptions3.totalOrdersChartData = this._.chain(this.dataFiltered)
            .groupBy("state_code")
            .map((value, key) => ({name: key, code: value[0].country_code, orders: value.length}))
            .value()
            .map(e => (e.code == "US") ? [`us-${e.name.toLowerCase()}`, e.orders] : [`ca-${e.name.toLowerCase()}`, e.orders])

        this.chartOptions3.gallonsChartData = this._.chain(this.dataFiltered)
            .groupBy("state_code")
            .map((value, key) => ({
              name: key,
              code: value[0].country_code,
              gallons: value.reduce((acc, e) => acc + e.gallons, 0)
            }))
            .value()
            .map(e => (e.code == "US") ? [`us-${e.name.toLowerCase()}`, e.gallons] : [`ca-${e.name.toLowerCase()}`, e.gallons])

        let totalOrdersForChart = []

        emptyData.map(e => {
          let isFound = false
          this.totalOrdersChartData.map(elem => {
            if (e[0] == elem[0]) {
              isFound = true
              totalOrdersForChart.push(elem)
            }
          })
          if (!isFound) {
            totalOrdersForChart.push(e)
          }
        })

        let gallonsForChart = []

        emptyData.map(e => {
          let isFound = false
          this.chartOptions.gallonsChartData.map(elem => {
            if (e[0] == elem[0]) {
              isFound = true
              gallonsForChart.push(elem)
            }
          })
          if (!isFound) {
            gallonsForChart.push(e)
          }
        })

        let saleForChart = []

        emptyData.map(e => {
          let isFound = false
          this.chartOptions.salePriceChartData.map(elem => {
            if (e[0] == elem[0]) {
              isFound = true
              saleForChart.push(elem)
            }
          })
          if (!isFound) {
            saleForChart.push(e)
          }
        })

        this.chartOptions.series[0].data = totalOrdersForChart
        this.chartOptions2.series[0].data = gallonsForChart
        this.chartOptions3.series[0].data = saleForChart

      } else {
        this.chartOptions.series[0].data = emptyData
        this.chartOptions.gallonsChartData = 0
        this.chartOptions.salePriceChartData = 0

        this.chartOptions2.series[0].data = emptyData
        this.chartOptions2.salePriceChartData = 0
        this.chartOptions2.totalOrdersChartData = 0

        this.chartOptions3.series[0].data = emptyData
        this.chartOptions3.totalOrdersChartData = 0
        this.chartOptions3.gallonsChartData = 0
      }
    },
    cleanFilters() {
      this.search = ''
    },
    rowClick: function (item, row) {
      let selectState = (row.isSelected) ? false : true
      row.select(selectState)
    },
    redirectToSalesReport(item) {
      let orders = JSON.stringify({
        report: 'geoSalesReport',
        order_ids: item.order_ids,
        dateStart: this.dateStart,
        dateEnd: this.dateEnd,
        defaultPeriod: this.defaultPeriod
      })
      localStorage.setItem('orders', orders)
      let routeData = this.$router.resolve({name: 'sales'})
      window.open(routeData.href, '_blank')
    }
  }
}
</script>

<style scoped>
.btn-right-arrow-adw,
.btn-right-arrow-bing,
.btn-right-arrow-other {
  right: 0px;
  top: 90px;
}

.btn-left-arrow-adw,
.btn-left-arrow-bing,
.btn-left-arrow-other {
  left: 0px;
  top: 90px;
}

.compare-text {
  font-size: 0.87em !important;
}

.compare-icon {
  font-size: 0.95em !important;
}
</style>

<style>
.google-map {
  width: 100%;
  height: 450px;
}

.v-chip.v-size--default {
  border-radius: 16px;
  font-size: 11px;
  height: 20px;
}

.v-select.v-input--dense .v-chip {
  margin: 4px 4px 0px 0px;
}

.chip-counter {
  font-size: 10px;
  margin: 4px 0px 0px 0px;
}
</style>